import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import '../../styles/modals/uploadProgressModal.css';

const UploadProgressModal = ({ isOpen, filesProgress, totalProgress }) => {
  // 모달이 열리면 페이지 스크롤 방지
  useEffect(() => {
    if (isOpen) {
      // 모달이 열리면 배경 스크롤 방지
      document.body.style.overflow = 'hidden';
      
      // 컴포넌트 언마운트 시 원래대로 복원
      return () => {
        document.body.style.overflow = 'auto';
      };
    }
  }, [isOpen]);

  if (!isOpen) return null;
  
  // 복사 중인 파일이 있는지 확인
  const hasCopyingFiles = filesProgress.some(file => file.name.includes('(copying...)'));

  return (
    <div className="upload-progress-modal-overlay">
      <div className="upload-progress-modal">
        <div className="upload-progress-modal-content">
          <h3>{hasCopyingFiles ? '파일 복사 중' : '파일 업로드 중'}</h3>
          <p className="upload-warning">업로드가 완료될 때까지 페이지를 닫거나 이동하지 마세요.</p>
          
          <div className="total-progress-container">
            <div className="progress-label-container">
              <span className="progress-title">전체 진행 상태:</span>
              <span className="progress-percentage">{Math.round(totalProgress)}%</span>
            </div>
            <div className="progress-bar-container">
              <div 
                className="progress-bar" 
                style={{ width: `${totalProgress}%` }}
              ></div>
            </div>
          </div>
          
          {filesProgress.length > 0 && (
            <div className="files-progress-container">
              <h4>개별 파일 진행 상태:</h4>
              {filesProgress.map((file, index) => (
                <div key={index} className="file-progress">
                  <div className="progress-label-container">
                    <span className="file-name">{file.name}</span>
                    <span className="progress-percentage">{Math.round(file.progress)}%</span>
                  </div>
                  <div className="progress-bar-container">
                    <div 
                      className="progress-bar" 
                      style={{ width: `${file.progress}%` }}
                    ></div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

UploadProgressModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  filesProgress: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      progress: PropTypes.number.isRequired
    })
  ).isRequired,
  totalProgress: PropTypes.number.isRequired
};

export default UploadProgressModal; 